import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $signUpFormTranslations = combine(i18n.$t, ({ t }) => {
  return {
    title: t('sign_up'),
    redirectQuestion: t('account_do_you_have'),
    redirectLink: t('sign_in'),
  }
})
